import { Observable, tap } from 'rxjs';

import { Container, Service } from '../../../../symphony';

import { SlApiService } from '../sl-api.service';
import { SlDataService } from '../sl-data.service';
import { SlDiscussContext } from '../../global-constants';
import { getBackendErrorMessage } from '../../utils/helpers';
import { IFlashMessageTypes } from '../../../../shared/public/SlFlashMessage/SlFlashMessage';
import { IDiscussVoteResponseData } from '../../../../api/public/discuss-api';

@Service()
export class SlVotingService {
	private api = Container.take(SlDiscussContext, SlApiService);

	private dataService = Container.take(SlDiscussContext, SlDataService);

	private updateQuestionVoteNumber = (votes: number, vote: number) => {
		this.dataService.question$.next({
			...this.dataService.question$.value,
			votes,
			vote,
		});
	};

	private updateReplyVoteNumber = (
		votes: number,
		vote: number,
		postId: string,
	) => {
		const updatedReplies = this.dataService.replies$.value.map((reply) => {
			if (reply.id === +postId) {
				return {
					...reply,
					votes,
					vote,
				};
			}

			return reply;
		});

		this.dataService.replies$.next(updatedReplies);
	};

	private getNewVote = (postId: string, isQuestion: boolean) => {
		let vote = 0;

		if (!isQuestion) {
			vote = this.dataService.replies$.value.find(
				(reply) => reply.id === +postId,
			).vote;
		} else {
			vote = this.dataService.question$.value.vote;
		}

		const newVote = vote === 0 ? 1 : 0;

		return newVote;
	};

	public updatePositiveReaction = (
		postId: string,
	): Observable<IDiscussVoteResponseData> => {
		const isQuestion = +postId === this.dataService.question$.value.id;
		const newVote = this.getNewVote(postId, isQuestion);

		return this.api.votePost(postId, newVote).pipe(
			tap((res) => {
				if (res.error) {
					this.dataService.notificationData$.next({
						message: getBackendErrorMessage(res.error.data),
						type: IFlashMessageTypes.ERROR,
					});

					return;
				}

				if (isQuestion) {
					this.updateQuestionVoteNumber(res.votes, newVote);
				} else {
					this.updateReplyVoteNumber(res.votes, newVote, postId);
				}
			}),
		);
	};
}
